import script from "./dispose-file-context-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./dispose-file-context-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__